/**
 * Защищённый роут: гостя уводит на вход, запомнив, куда он шёл.
 *
 * Уводит именно навигацией, а не подменой содержимого: страница задачи
 * (фаза 1.5) хранит черновик запроса в localStorage, поэтому возврат
 * по сохранённому пути возвращает и черновик (docs/10-ui-ux.md).
 */

import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'

import { useCurrentUser } from '@/api/auth'
import { strings } from '@/lib/strings'

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation()
  const { data: user, isPending } = useCurrentUser()

  if (isPending) {
    // Пока идёт проверка сессии, редиректить нельзя: после перезагрузки
    // страницы токена ещё нет, и авторизованный пользователь улетел бы на вход.
    return <p className="text-sm text-muted">{strings.auth.checking}</p>
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }

  return <>{children}</>
}
